/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
*/
import {useSelector} from 'react-redux';
import {useAuthenticatedUser} from '../pages/admin/users/useAuthenticatedUser';
import {globalGroupSelector} from '../store/selectors/global-group';

/**
 * Custom hook for retrieving the current global group, and if unavailable,
 * defaults to the currently authenticated user's account.
 */
export const useCurrentGlobalGroup = () => {
  const {account} = useAuthenticatedUser();
  return useSelector(globalGroupSelector) || account;
};
export default useCurrentGlobalGroup;
